const fieldTime = document.getElementById("inputTime");
const priceBlock = document.getElementById("priceBlock");
const lengthBlock = document.getElementById("lengthBlock");
const textPrice = document.getElementById("price");
const inputTimePrice = document.getElementById("inputTimePrice");
const inputLengthPrice = document.getElementById("inputLengthPrice");
const inputLength = document.getElementById("inputLength");
const inputFrom =  document.getElementById("inputFrom");
const inputTo = document.getElementById("inputTo");


if (transport.type === "lorry") {
    ymaps.ready(init);
    lengthBlock.classList.remove("d-none");
    document.getElementById("labelPrice").innerText = 'Ориентировочная стоимость';
}
// https://yandex.ru/dev/maps/jsbox/2.1/deliveryCalculator
function init() {
    const myMap = new ymaps.Map('map', {
            center: [56.100111, 37.106356],
            zoom: 9,
            controls: []
        }),
        // Создадим панель маршрутизации.
        routePanelControl = new ymaps.control.RoutePanel({
            options: {
                // Добавим заголовок панели.
                showHeader: true,
                title: 'Введите маршрут'
            }
        }),
        zoomControl = new ymaps.control.ZoomControl({
            options: {
                size: 'small',
                float: 'none',
                position: {
                    bottom: 145,
                    right: 10
                }
            }
        });
    // Пользователь сможет построить только автомобильный маршрут.
    routePanelControl.routePanel.options.set({
        types: {auto: true}
    });

    myMap.controls.add(routePanelControl).add(zoomControl);

    // Получим ссылку на маршрут.
    routePanelControl.routePanel.getRouteAsync().then(function (route) {

        // Зададим максимально допустимое число маршрутов, возвращаемых мультимаршрутизатором.
        route.model.setParams({results: 1}, true);

        // Повесим обработчик на событие построения маршрута.
        route.model.events.add('requestsuccess', function () {

            const activeRoute = route.getActiveRoute();
            if (activeRoute) {
                // Получим протяженность маршрута.
                let length = route.getActiveRoute().properties.get("distance"),
                    // Вычислим стоимость доставки.
                    price = calculate(Math.round(length.value / 1000)),
                    // Создадим макет содержимого балуна маршрута.
                    balloonContentLayout = ymaps.templateLayoutFactory.createClass(
                        '<span>Расстояние: ' + length.text + '.</span><br/>');
                        //+ '<span style="font-weight: bold; font-style: italic">Стоимость доставки: ' + price + ' р.</span>');
                // Зададим этот макет для содержимого балуна.
                route.options.set('routeBalloonContentLayout', balloonContentLayout);
                // Откроем балун.
                activeRoute.balloon.open();

                let fromCoords = routePanelControl.routePanel.state.get("from"),
                    toCoords   = routePanelControl.routePanel.state.get("to");

                inputLengthPrice.value = price.toString();
                inputLength.value = length.text;
                refreshPrice();

                    // Определяем адрес по координатам (обратное геокодирование)
                ymaps.geocode(fromCoords).then(function (res) {
                    let firstGeoObject = res.geoObjects.get(0);
                    let address = firstGeoObject.getAddressLine();
                    inputFrom.value = address + ' (' + fromCoords[0] + ', ' + fromCoords[1] + ')';
                });
                ymaps.geocode(toCoords).then(function (res) {
                    let firstGeoObject = res.geoObjects.get(0);
                    let address = firstGeoObject.getAddressLine();
                    inputTo.value = address + ' (' + toCoords[0] + ', ' + toCoords[1] + ')';
                });

            }
        });

    });
    // Функция, вычисляющая стоимость доставки.
    function calculate(routeLength) {
        return routeLength * transport["deliveryTariff"];
    }

}

function refreshPrice() {
    if (inputLengthPrice.value !== undefined && inputTimePrice.value !== undefined) {
        textPrice.innerHTML = (parseInt(inputLengthPrice.value) + parseInt(inputTimePrice.value)).toString();
        priceBlock.classList.remove("d-none");
    }
}

function initCalculate() {
    let price = (parseInt(fieldTime.value) + transport["minDelivery"]) * transport["fee"];
    inputTimePrice.value = (price).toString();
    refreshPrice();
}

document.addEventListener("DOMContentLoaded", function() {
    initCalculate();
    fieldTime.addEventListener("change", function () {
        initCalculate();
    });
});
